import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, makeStyles, CircularProgress, FormHelperText } from '@material-ui/core';
import React from 'react';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { AxiosError, AxiosResponse } from 'axios';
import InfluencerService from '../../../Services/InfluencerService';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { format, parseISO } from 'date-fns';
import { CampaignModel } from '../../../Models/CampaignModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { theme } from '../../../theme';
import { Autocomplete } from '@material-ui/lab';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';

export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    toolbar: {
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    baritems: {
        width: '100%',
        paddingLeft: theme.spacing(3),
        maxWidth: '1152px',
    },
    itens: {
        width: '100%',
        color: 'primary',
    },
    loading: {
        minHeight: '80vh'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    root: {
        padding: theme.spacing(3),
        width: '100%',
        maxWidth: '1152px',
    },
    title: {
        margin: '20px 0px 32px'
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
}));

type ErrosFormulario = Partial<Record<keyof CampaignModel, string>>;

function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}

export default function InfluencerSingleCampaignSubmit() {
    const classes = useStyles();
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const [news, setNews] = React.useState<CampaignModel>({} as CampaignModel);
    const clientEnable = homeContext.influencerClientEnable;
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [loading, setLoading] = React.useState(false);
    const dataAtual = toBrasiliaISOString(new Date());


    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);

    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    const username = authContext.login.user.username;

                    setFiltersData(res.data);
                    setNews(prev => ({
                        ...prev,
                        id_usuario: authContext.login.user.id,
                        dataRecebimento: dataAtual,
                        id_solicitante: username || '',
                        email: authContext.login.user.email || '',
                    }));
                    // setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });

            const userId = authContext.login.user.id;
            InfluencerService.getInfluencersResponsavelByUser(userId)
                .then((res: AxiosResponse) => {
                    setNews(prev => ({
                        ...prev,
                        responsavelReputacao: res.data.responsavel_reputacao[0]?.descricao,
                    }));
                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }
    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof CampaignModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };

    const handleChangeDate = (prop: keyof CampaignModel) =>
        (date: Date | null) => {
            if (date) {
                setNews(prevNews => ({
                    ...prevNews,
                    [prop]: toBrasiliaISOString(date),
                }));
            }
        };

    const handleChangeSelect = (prop: keyof CampaignModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event.target.value as string });
        };

    async function uploadCampaign(clearAfterSuccess = false) {
        const errosValidacao = validarCampos();

        if (Object.keys(errosValidacao).length > 0) {
            setErros(errosValidacao);
            return;
        }

        setErros({} as ErrosFormulario);

        const clientId = clientEnable?.id_cliente;
        setResultUpload(InfluencerUploadResultInitial);
        setLoading(true);

        if (clientId) {
            try {
                const updatedNews = {
                    ...news,
                    clientId,
                };

                setNews(updatedNews);

                if (updatedNews.clientId && updatedNews.id_usuario) {
                    await InfluencerSpreadsheetService.postCampaignDetachedICE(
                        authContext.login.user.id,
                        updatedNews
                    );
                    homeContext.showSuccess('Solicitação enviada com sucesso. O prazo para retorno da análise é de 5 dias úteis. Caso seu pedido tenha urgência, entre em contato com o time de comunicação no canal do Slack #fale-com-reputação-gb.');

                    if (clearAfterSuccess) {
                        clearInputs();
                    }
                }
            } catch (error) {
                homeContext.showError('Erro ao Salvar a Campanha.');
            } finally {
                setLoading(false);
            }
        }
    }

    const validarCampos = (): ErrosFormulario => {
        const novosErros: ErrosFormulario = {};

        const camposObrigatorios: (keyof CampaignModel)[] = [
            'area',
            'marca',
            'vp',
            'nome',
            'objetivo',
            'canais',
            'envolvimentoFiguraPublica',
            'periodoCampanha',
            'periodoCampanhaFim',
            'abrangencia',
        ];

        camposObrigatorios.forEach((campo) => {
            const valor = news[campo];
            if (typeof valor === 'string' && !valor.trim()) {
                novosErros[campo] = 'Campo obrigatório.';
            } else if (valor === null || valor === undefined) {
                novosErros[campo] = 'Campo obrigatório.';
            }
        });
        return novosErros;
    };


    const clearInputs = () => {
        setNews({
            ['id_usuario']: authContext.login.user.id,
            ['dataRecebimento']: toBrasiliaISOString(new Date()),
            ['id_solicitante']: news.id_solicitante,
            ['responsavelReputacao']: news.responsavelReputacao,
            ['email']: authContext.login.user.email || '',
        } as CampaignModel);
    };

    const hasDataFilled = () => {
        // Verifica se há dados preenchidos nos campos principais
        return (
            (news.area && news.area.trim() !== '') ||
            (news.marca && news.marca.trim() !== '') ||
            (news.vp && news.vp.trim() !== '') ||
            (news.nome && news.nome.trim() !== '') ||
            (news.objetivo && news.objetivo.trim() !== '') ||
            (news.canais && Array.isArray(news.canais) && news.canais.length > 0) ||
            (news.envolvimentoFiguraPublica !== null && news.envolvimentoFiguraPublica !== undefined) ||
            (news.periodoCampanha && news.periodoCampanha !== null) ||
            (news.periodoCampanhaFim && news.periodoCampanhaFim !== null) ||
            (news.abrangencia && news.abrangencia.trim() !== '') ||
            (news.publicoAlvo && news.publicoAlvo.trim() !== '') ||
            (news.observacoes && news.observacoes.trim() !== '')
        );
    };

    const handleGoToHome = () => {
        if (hasDataFilled()) {
            setShowConfirmExit(true);
        } else {
            homeContext.setPageLocation(PageLocation.INFLUENCER_HOME);
        }
    };

    const saveInputs = () => {
        return (
            <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={3}
            >
                <Grid
                    item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => uploadCampaign(true)}
                        size="large"
                        fullWidth>
                        {'Enviar'}
                    </Button>
                </Grid>
            </Grid>
        );
    };


    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Solicitação de Análise de Campanhas e Projetos
                    </Typography>
                </Grid>
                {/* <Grid
                    item
                    xs={12}
                >
                    <Typography variant="body1">
                        Para incluir um novo perfil, insira os dados solicitados abaixo
                    </Typography>
                </Grid> */}
            </Grid>
        );
    };

    const inputDataRecebimento = () => {
        const dataAtualFormatada = format(new Date(), 'dd/MM/yyyy');
        return (
            <Grid item xs={4}>
                <TextField
                    id="news-date"
                    label="Data"
                    value={dataAtualFormatada}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </Grid>
        );
    };


    const inputNome = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nome"
                        value={news.nome || ''}
                        onChange={handleChange('nome')}
                        label="Nome da campanha ou projeto"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} required error={!!erros.nome}
                    />
                    {erros.nome && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };

    const inputSolicitante = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="solicitante"
                        value={news.id_solicitante || ''}
                        label="Solicitante"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const inputResponsavelReputacao = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="responsavelReputacao"
                        value={news.responsavelReputacao ?? ''}
                        // onChange={handleChangeSelect('responsavelReputacao')}
                        label="Responsável Reputação"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputEmail = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="Email"
                        value={news.email || ''}
                        // onChange={handleChange('Email')}
                        label="Email"
                        InputProps={{
                            readOnly: true,
                        }}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputPublicoAlvo = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="publicoAlvo"
                        value={news.publicoAlvo || ''}
                        onChange={handleChange('publicoAlvo')}
                        label="Público-alvo"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens}
                    />
                </Grid>
            </>
        );
    };

    const inputPeriodoCampanha = () => {
        return (
            <>
                <Grid item xs={8} style={{ marginBottom: 12 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils} >
                                <DatePicker
                                    id="news-date"
                                    variant="inline"
                                    value={news.periodoCampanha ?? null}
                                    inputVariant="outlined"
                                    label="Início do Período da campanha"
                                    minDate={new Date(0)}
                                    clearable
                                    emptyLabel=''
                                    onChange={handleChangeDate('periodoCampanha')}
                                    format="dd/MM/yyyy"
                                    className={classes.itens}
                                    required error={!!erros.periodoCampanha}
                                />
                                {erros.periodoCampanha && (
                                    <FormHelperText>Este campo é obrigatório.</FormHelperText>
                                )}
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils} >
                                <DatePicker
                                    id="news-date"
                                    variant="inline"
                                    value={news.periodoCampanhaFim ?? null}
                                    inputVariant="outlined"
                                    label="Fim do Período da campanha"
                                    minDate={new Date(0)}
                                    clearable
                                    emptyLabel=''
                                    onChange={handleChangeDate('periodoCampanhaFim')}
                                    format="dd/MM/yyyy"
                                    className={classes.itens}
                                    required error={!!erros.periodoCampanhaFim}
                                />
                                {erros.periodoCampanhaFim && (
                                    <FormHelperText>Este campo é obrigatório.</FormHelperText>
                                )}
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                </Grid >
            </>
        );
    };

    const inputObservacoes = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="observacaoes"
                        value={news.observacoes || ''}
                        onChange={handleChange('observacoes')}
                        label="Observações"
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputObjetivo = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="objetivo"
                        value={news.objetivo || ''}
                        onChange={handleChange('objetivo')}
                        label="Objetivo/ conceito da iniciativa"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens}
                        required error={!!erros.objetivo}
                    />
                    {erros.objetivo && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    const selectMarca = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.marca}
                >
                    <Autocomplete
                        id="marca-autocomplete"
                        options={filters?.marcas ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.marcas?.find(m => m.descricao === news.marca) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                marca: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Marca"
                                variant="outlined"
                                error={!!erros.marca}
                                required
                            />
                        )}
                    />
                    {erros.marca && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectArea = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.area}
                >
                    <Autocomplete
                        id="area-autocomplete"
                        options={filters?.area ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.area?.find(a => a.descricao === news.area) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                area: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Área"
                                variant="outlined"
                                error={!!erros.area}
                                required
                            />
                        )}
                    />
                    {erros.area && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectVp = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.vp}
                >
                    <Autocomplete
                        id="vp-autocomplete"
                        options={filters?.vp ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.vp?.find(v => v.descricao === news.vp) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                vp: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="VP"
                                variant="outlined"
                                error={!!erros.vp}
                                required
                            />
                        )}
                    />
                    {erros.vp && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectEnvolvimentoCampanha = () => {
        return (
            <>
                <Grid item xs={8}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required error={!!erros.envolvimentoFiguraPublica}
                    >
                        <InputLabel id="envolvimento-campanha" style={{ color: 'black', fontSize: '14px' }} >A campanha envolverá a contratação de figuras públicas (influenciadores ou celebridades)?</InputLabel>
                        <Select
                            labelId="envolvimento-campanha"
                            id="envolvimento-campanha"
                            value={news.envolvimentoFiguraPublica ?? ''}
                            label="A campanha envolverá a contratação de figuras públicas (influenciadores ou celebridades)?"
                            onChange={handleChangeSelect('envolvimentoFiguraPublica')}
                            style={{
                                outline: 'none',
                                borderBottom: 'none',
                            }}
                        >
                            <MenuItem value={undefined}>Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {erros.envolvimentoFiguraPublica && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </>
        );
    };




    const selectCanais = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.canais}
                >
                    <Autocomplete
                        multiple
                        id="canais-autocomplete"
                        options={filters?.canais ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.canais?.filter((c) => Array.isArray(news.canais) && news.canais.includes(c.descricao)) || []}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                canais: newValue.map((c) => c.descricao).filter(Boolean),
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Canais de divulgação"
                                variant="outlined"
                                error={!!erros.canais}
                                required
                            />
                        )}
                        disableCloseOnSelect
                    />
                    {erros.canais && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectAbrangencia = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.abrangencia}
                >
                    <Autocomplete
                        id="abrangencia-autocomplete"
                        options={filters?.abrangencia ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.abrangencia?.find(a => a.descricao === news.abrangencia) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                abrangencia: newValue ? newValue.descricao : '',
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Abrangência"
                                variant="outlined"
                                error={!!erros.abrangencia}
                                required
                            />
                        )}
                    />
                    {erros.abrangencia && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };





    const AccordionProfileData = () => {
        return (
            <Grid>
                <Grid container spacing={4} >
                    {/* {inputResponsavelReputacao()} */}
                    {inputSolicitante()}
                    {inputEmail()}
                    {inputDataRecebimento()}
                    {selectArea()}
                    {selectMarca()}
                    {selectVp()}
                    {inputNome()}
                    {inputObjetivo()}
                    {selectCanais()}
                    {inputPublicoAlvo()}
                    {inputPeriodoCampanha()}
                    {selectEnvolvimentoCampanha()}
                    {selectAbrangencia()}
                    {inputObservacoes()}
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            {!loading &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid container className={classes.toolbar} justifyContent="center"
                        alignItems="center">
                        <Grid
                            item
                            className={classes.baritems}
                            direction="column"
                        >
                            <Button
                                variant="text"
                                onClick={handleGoToHome}
                                style={{
                                    textTransform: 'initial',
                                    color: theme.palette.primary.main,
                                    padding: '8px 0px',
                                    fontSize: '14px'
                                }}
                            >
                                ← Voltar para a página inicial
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        className={classes.root}
                        direction="column"
                    >
                        <Grid
                            container
                            direction="row"
                            className={classes.root}
                            spacing={4}
                            alignItems="center"
                        >
                            {inputTitleAndSubtitle()}
                        </Grid>
                        <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12}>{AccordionProfileData()}</Grid>
                            <Grid item xs={12}>{saveInputs()}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {loading && <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.loading}>
                <CircularProgress color="primary" size="124px" />
            </Grid>}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de solicitação já preenchidos."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_HOME)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}